import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../CsStyles";

import { Box, Grid, TextField, Typography } from '@material-ui/core';

class Link extends React.Component {
    constructor(props) {
        super(props);
        this.props.funcs.setName("link");
        this.props.funcs.setValue(this.props.bar.state.value);
    }

    render() {
        var value = this.props.bar.state.value;

        return (
            <React.Fragment>
                <Grid item>
                    <Typography variant='h6'>Link</Typography>
                </Grid>
                <Grid item xs>
                    <TextField InputLabelProps={{ shrink: false }} value={value} fullWidth onChange={e => this.props.funcs.setValue(e.target.value)} />
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Link);